<div *ngIf="resolveUser">
  <router-outlet></router-outlet>
</div>
